import { render, staticRenderFns } from "./FooterComponents.vue?vue&type=template&id=27a690a4"
import script from "./FooterComponents.vue?vue&type=script&lang=js"
export * from "./FooterComponents.vue?vue&type=script&lang=js"
import style0 from "./FooterComponents.vue?vue&type=style&index=0&id=27a690a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports